import axios from "axios";
import { toast } from "react-toastify";
import { getToken } from "./tokenService.js";
import { baseapi } from "../Environmentalurl";
import { entity_id } from "./Const.js";
import getIPAddress from "./useIPAddress.js";

const api = axios.create({
  baseURL: baseapi,
});

// Same key/message SessionManager.js uses for its "session expired" popup
// on /login mount, so both paths produce a consistent experience.
const SESSION_EXPIRED_KEY = "SESSION_EXPIRED";
const SESSION_EXPIRED_MSG =
  "Your session has expired. Please log in again.";

// ── Token validation / session-extend helper ───────────────────────────────
// This is THE place session expiry is decided. The backend is the single
// source of truth: whenever ANY API call comes back with
// Response_Code "99723" (Session Expired), we call ValidateJwtToken right
// then. If the backend says the session is still good, we treat it as
// extended and let the user keep working — no client-side clock involved.
const validateToken = async () => {
  try {
    const token = getToken();

    const mobileNumber = JSON.parse(
      sessionStorage.getItem("mobileNumber") || "null",
    );

    const entityId = entity_id;

    // Get IP Address
    const ip = await getIPAddress();

    const res = await axios.post(`${baseapi}/services/auth/validatejwttoken`, {
      ReqType: "ValidateJwtToken",
      Mobilenumber: mobileNumber,
      EntityID: entityId,
      MachineID: ip,
      Token: token,
    });

    return res.data?.Response_Code === "1000";
  } catch (error) {
    console.error("Token validation failed:", error);
    return false;
  }
};

// ── Request interceptor ────────────────────────────────────────────────────
api.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// ── Response interceptor ───────────────────────────────────────────────────
api.interceptors.response.use(
  async (response) => {
    const data = response.data;

    if (
      (data?.Response_Code === "99723" ||
        data?.Message === "Session Expired") &&
      !response.config._retry
    ) {
      response.config._retry = true;

      const isValid = await validateToken();

      if (isValid) {
        // ✅ Backend confirmed the session is still good — tell the user
        // and quietly retry the original request so nothing is lost.
        toast.success("Session extended successfully", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
        });
        return api.request(response.config);
      }

      // ✅ Backend says the session genuinely cannot be extended.
      // Use the SAME flag SessionManager's inactivity logout uses, so the
      // /login page shows one consistent "session expired" message
      // regardless of which path triggered the logout.
      const theme = localStorage.getItem("themeMode");
      const walletToken = localStorage.getItem("SessionWalletToken");

      sessionStorage.clear();
      localStorage.clear();

      if (theme) localStorage.setItem("themeMode", theme);
      if (walletToken !== null)
        localStorage.setItem("SessionWalletToken", walletToken);
      localStorage.setItem(SESSION_EXPIRED_KEY, SESSION_EXPIRED_MSG);

      window.location.replace("/login");

      return Promise.reject(new Error("Session Expired"));
    }

    return response;
  },
  (error) => Promise.reject(error),
);

export default api;